<template>
  <div v-if="productData" class="col-12 advCartRow">
    <div v-if="checkoutCart && !miniCart">
      <div class="d-flex-100 align-content-start minicartItem">
        <div class="col-12" v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
          <div class="col-2 p-0 m-0"></div>
          <div class="col-10 p-0 m-0">
            <adv-cart-product-bundle-display
              class="col-12 p-0 m-0"
              :cart-product="cartProduct"
              :product-data="productData"
              style-type="smart"
            />
          </div>
        </div>
        <div class="col-3 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
            </div>
          </div>
        </div>
        <div class="col-9 d-flex-100 hp-0 cart_item_info">
          <button v-on:click="removeProductFromCart" :disabled="!onlineStatus" class="action-item rem-minicart-prod pt-0" v-if="readOnly">
            <i class="lni lni-trash"></i>
          </button>
          <div class="d-flex-100 align-content-center align-items-center cart_item_name">
            {{ decodeHtmlEntities(productData.productName) }}
          </div>
          <div class="d-flex-100 align-content-center align-items-center minicart-input-col" >
            <adv-cart-input-spinner
              class="quantitySpinner"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="d-flex-100 mt-3 align-content-center align-items-center text-left minicart-price">
            <span>
              {{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="miniCart && !checkoutCart">
      <div class="d-flex-100 align-content-start minicartItem">
        <div class="col-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
            </div>
          </div>
        </div>
        <div class="col-10 d-flex-100 hp-0 cart_item_info">
          <button v-on:click="removeProductFromCart" :disabled="!onlineStatus" class="action-item rem-minicart-prod pt-0" v-if="!readOnly">
            <i class="lni lni-trash"></i>
          </button>
          <div class="d-flex-100 align-content-center align-items-center cart_item_name">
            {{ decodeHtmlEntities(productData.productName) }}
          </div>
          <div class="d-flex-100 align-content-center align-items-center minicart-input-col" v-if="!readOnly">
            <adv-cart-input-spinner
              class="quantitySpinner"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
          <div class="d-flex-100 align-content-center align-items-center text-left minicart-price">
            <div class="minicart-price-text">{{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span></div>
          </div>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="col-12 text-left minicart-quantity" v-if="readOnly">
              <span>
                {{ t('quantity') }}: {{ cartProduct.quantity }}
              </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!miniCart && !checkoutCart">
      <div class="d-flex-100 align-items-start minicart-item-row">
        <div class="col-12 text-center helpCartMsg m-3" v-show="cartError && !readOnly">
          <span><i class="ti-info-alt"></i> {{ cartError }}</span>
        </div>
        <div class="col-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="imageSrc" :alt="productData.productName">
            </div>
          </div>
        </div>
        <div class="d-flex flex-wrap align-content-start col-10 col-sm-4 col-5 col-md-4 minicart-item-title">
          <div class="db-100 minicart-item-code">
            {{
              t('minicart.product_code', {
                params: [{
                  productCode: cartProduct.productCodeId
                }]
              })
            }}
          </div>
          <template v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
            <adv-cart-product-bundle-display
              class="col-12 p-0"
              :cart-product="cartProduct"
              :product-data="productData"
              :expanded="true"
              style-type="smart"
            />
          </template>
          <a :href="productData.productUrl">
            {{ productData.productName }}
          </a>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="db-100 minicart-item-price"><span>{{ t('price') }} / {{ t('package') }}:</span>
            <b><span v-html="finalPriceWithSign"></span></b>
          </div>
        </div>
        <div class="d-flex flex-wrap align-self-center col-4 col-md-3 minicart-item-quantity" v-if="!readOnly">
          <adv-cart-input-spinner
            class="quantitySpinner"
            :product-code-id="cartProduct.productCodeId"
            :quantity="cartProduct.quantity"
            v-on:quantity-changed="updateProductQuantity">
          </adv-cart-input-spinner>
        </div>
        <div class="col-6 offset-2 col-sm-4 col-md-3 minicart-item-quantity advSpinnerRow" v-if="readOnly">
          {{ cartProduct.quantity }}
        </div>
        <div class="d-flex flex-wrap align-self-center col-4 col-sm-12 col-md-2 advCartRowTotal">
          <div class="advCart-discount-row" v-show="productData.productHasDiscount" >
            <small class="advCartDiscTtl">{{ t('discount') }}</small>
            <span class="advCartDiscPerc">
              <b>{{ productData.productDisclosure }}</b>
            </span>
          </div>
          <span v-show="productData.productHasDiscount" class="advCartPrevPrice" v-html="originalTotalPriceWithSign"></span>
          <span class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></span>
        </div>
        <a href="#" v-on:click="removeProductFromCart"  v-if="!readOnly" :disabled="!onlineStatus" class="action-item">
          <img src="/ui/main/img/cart-trash-icon.webp" width="36" height="36" class="img-fluid aspect-img">
        </a>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvCartInputSpinner from './AdvCartInputSpinner'
import AdvCartProductCustomizationDisplayValues
  from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AdvCartProductBundleDisplay from './AdvCartProductBundleDisplay.vue'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvCartProductCustomizationDisplayValues,
    AdvCartProductBundleDisplay,
    AdvCartInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    checkoutCart: {
      type: Boolean,
      default: false
    },
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    formattedCartTotal() {
      let formatted = (this.cartTotal * this.selectedCurrency.rate).toFixed(2).replace('.', ',');
      return formatted.split(',');
    },
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign() {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * this.selectedCurrency.rate;
      return this.formatPrice(price, this.selectedCurrency);
    },
    finalPriceWithSign() {
      const price = this.productData.productFinalPrice * this.selectedCurrency.rate;
      return this.formatPrice(price, this.selectedCurrency);
    },
    finalTotalPriceWithSign() {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * this.selectedCurrency.rate;
      return this.formatPrice(price, this.selectedCurrency);
    },
    productData () {
      const productData = store.getters.getProductById(this.cartProduct.productId)
      const cartProductData = store.getters.getCartProductById(this.cartProduct.productId)
      return {
        ...productData,
        ...cartProductData
      }
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
      decodeHtmlEntities(str) {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
      },
    formatPrice(finalPrice, currency) {
      const formattedPrice = finalPrice.toFixed(2).replace('.', ',');

      const [integerPart, fractionalPart] = formattedPrice.split(',');

      return `
      <span>${integerPart}</span>
      <span class='fractional'>,${fractionalPart}${currency.symbol}</span>
    `;
    },
    removeProductFromCart () {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: 0
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    },
    updateProductQuantity (quantity) {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    }
  }
}
</script>
